/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputSuggestedSearchWord } from './InputSuggestedSearchWord';
import {
    InputSuggestedSearchWordFromJSON,
    InputSuggestedSearchWordFromJSONTyped,
    InputSuggestedSearchWordToJSON,
    InputSuggestedSearchWordToJSONTyped,
} from './InputSuggestedSearchWord';
import type { InputVideoCaptionInfo } from './InputVideoCaptionInfo';
import {
    InputVideoCaptionInfoFromJSON,
    InputVideoCaptionInfoFromJSONTyped,
    InputVideoCaptionInfoToJSON,
    InputVideoCaptionInfoToJSONTyped,
} from './InputVideoCaptionInfo';
import type { InputAlgorithmScores } from './InputAlgorithmScores';
import {
    InputAlgorithmScoresFromJSON,
    InputAlgorithmScoresFromJSONTyped,
    InputAlgorithmScoresToJSON,
    InputAlgorithmScoresToJSONTyped,
} from './InputAlgorithmScores';
import type { ViewType } from './ViewType';
import {
    ViewTypeFromJSON,
    ViewTypeFromJSONTyped,
    ViewTypeToJSON,
    ViewTypeToJSONTyped,
} from './ViewType';
import type { InputPromotedProduct } from './InputPromotedProduct';
import {
    InputPromotedProductFromJSON,
    InputPromotedProductFromJSONTyped,
    InputPromotedProductToJSON,
    InputPromotedProductToJSONTyped,
} from './InputPromotedProduct';

/**
 * 
 * @export
 * @interface InputUserVideoData
 */
export interface InputUserVideoData {
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    awemeId: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    videoLink: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    authorId: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    authorUniqueUsername: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    authorDisplayName: string;
    /**
     * 
     * @type {Array<InputVideoCaptionInfo>}
     * @memberof InputUserVideoData
     */
    captionInfos: Array<InputVideoCaptionInfo>;
    /**
     * 
     * @type {Array<InputSuggestedSearchWord>}
     * @memberof InputUserVideoData
     */
    suggestedSearches: Array<InputSuggestedSearchWord>;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    creationTime: number;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    locationCreated: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputUserVideoData
     */
    categories?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    promotionType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    awemeType?: number;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    awemeTypeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    sessionId: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    watchDuration: number;
    /**
     * 
     * @type {ViewType}
     * @memberof InputUserVideoData
     */
    eventType: ViewType;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    likesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    commentsAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    sharesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    favoritesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    viewsAmounts: number;
    /**
     * 
     * @type {InputAlgorithmScores}
     * @memberof InputUserVideoData
     */
    algorithmScores?: InputAlgorithmScores | null;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    watchedTime: number;
    /**
     * 
     * @type {number}
     * @memberof InputUserVideoData
     */
    taskExecutionId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    searchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    searchKeyword?: string | null;
    /**
     * 
     * @type {Array<InputPromotedProduct>}
     * @memberof InputUserVideoData
     */
    promotedProducts?: Array<InputPromotedProduct> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InputUserVideoData
     */
    itemSummary?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    feedRequestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    gcsVideoKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InputUserVideoData
     */
    viewUuid?: string | null;
}



/**
 * Check if a given object implements the InputUserVideoData interface.
 */
export function instanceOfInputUserVideoData(value: object): value is InputUserVideoData {
    if (!('awemeId' in value) || value['awemeId'] === undefined) return false;
    if (!('videoLink' in value) || value['videoLink'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('authorId' in value) || value['authorId'] === undefined) return false;
    if (!('authorUniqueUsername' in value) || value['authorUniqueUsername'] === undefined) return false;
    if (!('authorDisplayName' in value) || value['authorDisplayName'] === undefined) return false;
    if (!('captionInfos' in value) || value['captionInfos'] === undefined) return false;
    if (!('suggestedSearches' in value) || value['suggestedSearches'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('locationCreated' in value) || value['locationCreated'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    if (!('watchDuration' in value) || value['watchDuration'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('likesAmount' in value) || value['likesAmount'] === undefined) return false;
    if (!('commentsAmount' in value) || value['commentsAmount'] === undefined) return false;
    if (!('sharesAmount' in value) || value['sharesAmount'] === undefined) return false;
    if (!('favoritesAmount' in value) || value['favoritesAmount'] === undefined) return false;
    if (!('viewsAmounts' in value) || value['viewsAmounts'] === undefined) return false;
    if (!('watchedTime' in value) || value['watchedTime'] === undefined) return false;
    return true;
}

export function InputUserVideoDataFromJSON(json: any): InputUserVideoData {
    return InputUserVideoDataFromJSONTyped(json, false);
}

export function InputUserVideoDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUserVideoData {
    if (json == null) {
        return json;
    }
    return {
        
        'awemeId': json['aweme_id'],
        'videoLink': json['video_link'],
        'description': json['description'],
        'authorId': json['author_id'],
        'authorUniqueUsername': json['author_unique_username'],
        'authorDisplayName': json['author_display_name'],
        'captionInfos': ((json['caption_infos'] as Array<any>).map(InputVideoCaptionInfoFromJSON)),
        'suggestedSearches': ((json['suggested_searches'] as Array<any>).map(InputSuggestedSearchWordFromJSON)),
        'creationTime': json['creation_time'],
        'locationCreated': json['location_created'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'promotionType': json['promotion_type'] == null ? undefined : json['promotion_type'],
        'awemeType': json['aweme_type'] == null ? undefined : json['aweme_type'],
        'awemeTypeLabel': json['aweme_type_label'] == null ? undefined : json['aweme_type_label'],
        'userId': json['user_id'],
        'sessionId': json['session_id'],
        'watchDuration': json['watch_duration'],
        'eventType': ViewTypeFromJSON(json['event_type']),
        'likesAmount': json['likes_amount'],
        'commentsAmount': json['comments_amount'],
        'sharesAmount': json['shares_amount'],
        'favoritesAmount': json['favorites_amount'],
        'viewsAmounts': json['views_amounts'],
        'algorithmScores': json['algorithm_scores'] == null ? undefined : InputAlgorithmScoresFromJSON(json['algorithm_scores']),
        'watchedTime': json['watched_time'],
        'taskExecutionId': json['task_execution_id'] == null ? undefined : json['task_execution_id'],
        'searchId': json['search_id'] == null ? undefined : json['search_id'],
        'searchKeyword': json['search_keyword'] == null ? undefined : json['search_keyword'],
        'promotedProducts': json['promoted_products'] == null ? undefined : ((json['promoted_products'] as Array<any>).map(InputPromotedProductFromJSON)),
        'itemSummary': json['item_summary'] == null ? undefined : json['item_summary'],
        'feedRequestId': json['feed_request_id'] == null ? undefined : json['feed_request_id'],
        'gcsVideoKey': json['gcs_video_key'] == null ? undefined : json['gcs_video_key'],
        'viewUuid': json['view_uuid'] == null ? undefined : json['view_uuid'],
    };
}

export function InputUserVideoDataToJSON(json: any): InputUserVideoData {
    return InputUserVideoDataToJSONTyped(json, false);
}

export function InputUserVideoDataToJSONTyped(value?: InputUserVideoData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'aweme_id': value['awemeId'],
        'video_link': value['videoLink'],
        'description': value['description'],
        'author_id': value['authorId'],
        'author_unique_username': value['authorUniqueUsername'],
        'author_display_name': value['authorDisplayName'],
        'caption_infos': ((value['captionInfos'] as Array<any>).map(InputVideoCaptionInfoToJSON)),
        'suggested_searches': ((value['suggestedSearches'] as Array<any>).map(InputSuggestedSearchWordToJSON)),
        'creation_time': value['creationTime'],
        'location_created': value['locationCreated'],
        'categories': value['categories'],
        'promotion_type': value['promotionType'],
        'aweme_type': value['awemeType'],
        'aweme_type_label': value['awemeTypeLabel'],
        'user_id': value['userId'],
        'session_id': value['sessionId'],
        'watch_duration': value['watchDuration'],
        'event_type': ViewTypeToJSON(value['eventType']),
        'likes_amount': value['likesAmount'],
        'comments_amount': value['commentsAmount'],
        'shares_amount': value['sharesAmount'],
        'favorites_amount': value['favoritesAmount'],
        'views_amounts': value['viewsAmounts'],
        'algorithm_scores': InputAlgorithmScoresToJSON(value['algorithmScores']),
        'watched_time': value['watchedTime'],
        'task_execution_id': value['taskExecutionId'],
        'search_id': value['searchId'],
        'search_keyword': value['searchKeyword'],
        'promoted_products': value['promotedProducts'] == null ? undefined : ((value['promotedProducts'] as Array<any>).map(InputPromotedProductToJSON)),
        'item_summary': value['itemSummary'],
        'feed_request_id': value['feedRequestId'],
        'gcs_video_key': value['gcsVideoKey'],
        'view_uuid': value['viewUuid'],
    };
}

